import { Table } from 'portal-commons';
import React, { FunctionComponent } from 'react';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';
import { Grid } from '@material-ui/core';

import SectionHeader from '../SectionHeader';
import { Event } from '../../../Events/types';
import EventListingRow from '@/components/EventListingRow';

interface EventsSectionProps {
  loading: boolean;
  events: Event[];
  pagination: {
    page: number;
    rowsPerPage: number;
    totalRecords: number;
  };
  onPageChange: (page: number) => void;
}

export const headRows = [
  { id: 'eventType', label: 'EVENT TYPE', sortable: false },
  { id: 'categoryType', label: 'CATEGORY', sortable: false },
  { id: 'campaignUid', label: 'CAMPAIGN ID', sortable: false },
  { id: 'brandUid', label: 'BRAND ID', sortable: false },
  { id: 'updateDate', label: 'DATE & TIME', sortable: false },
  { id: 'authenticatedUser', label: 'USER', sortable: false },
  { id: 'description', label: 'DESCRIPTION', sortable: false },
];

const EventsSection: FunctionComponent<EventsSectionProps> = ({
  loading,
  events,
  pagination,
  onPageChange,
}) => {
  return (
    <Grid item xs={12}>
      <div
        className="campaign-events details"
        data-testid="campaignDetailEvents"
      >
        <SectionHeader icon={faCalendarRange} title={'Events'} />
        <Grid container>
          <Table
            testId="campaignDetailEventsTable"
            className="campaign-detail-events-table"
            headRows={headRows}
            emptyState="no events to view"
            disableHover
            loading={loading}
            tableData={events.map((record, index) => (
              <EventListingRow key={index} event={record} brandLink />
            ))}
            handleChangePage={onPageChange}
            pagination={pagination}
          />
        </Grid>
      </div>
    </Grid>
  );
};

export default EventsSection;
